import { useEffect, useState } from "react";
import { apiFetch } from "../api"; // your existing apiFetch
import {BASE_URL as u} from "../../commonUrls";

const BASE_URL = `${u}`;

export default function FileVault(){

  const [files, setFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);

  useEffect(()=>{
    loadFiles();
  },[]);

  const loadFiles = async ()=>{
    const res = await apiFetch(`${BASE_URL}/files`);
    const data = await res.json();
    setFiles(data || []);
  };

  /* ---------- UPLOAD ---------- */

  const uploadFiles = async ()=>{
    if(selectedFiles.length === 0) return;

    const fd = new FormData();
    selectedFiles.forEach(f => fd.append("files", f));

    await apiFetch(`${BASE_URL}/files/upload`, {
      method:"POST",
      body: fd
    });

    setSelectedFiles([]);
    loadFiles();
  };

  return (
    <div style={wrap}>

      <h2>📁 File Vault</h2>

      {/* Upload */}
      <div style={uploadBox}>
        <input 
          type="file" 
          multiple 
          onChange={e=>setSelectedFiles([...e.target.files])}
        />

        <button onClick={uploadFiles}>
          ⬆ Upload Files
        </button>
      </div>

      {/* List */}
      <div style={listWrap}>
        {files.length === 0 && <p style={{color:"#888"}}>No files uploaded</p>}

        {files.map(f=>(
          <div key={f.id} style={fileCard}>
            <div>
              <strong>📎 {f.fileName}</strong>
              <div style={meta}>
                {(f.fileSize/1024).toFixed(1)} KB · {f.fileType || "file"}
              </div>
            </div>

            <a
              href={`${BASE_URL}/files/${f.id}/download`}
              target="_blank"
              rel="noreferrer"
              style={downloadBtn}
            >
              ⬇ Download
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}

const wrap = {
  maxWidth:"800px",
  margin:"0 auto",
  padding:"24px"
};

const uploadBox = {
  display:"flex",
  gap:"12px",
  alignItems:"center",
  marginBottom:"20px",
  padding:"16px",
  border:"1px dashed #ccc",
  borderRadius:"12px",
  background:"#fafafa"
};

const listWrap = {
  display:"flex",
  flexDirection:"column",
  gap:"10px"
};

const fileCard = {
  display:"flex",
  justifyContent:"space-between",
  alignItems:"center",
  padding:"12px 16px",
  border:"1px solid #eee",
  borderRadius:"12px",
  background:"#fff",
  boxShadow:"0 4px 10px rgba(0,0,0,0.04)"
};

const meta = {
  fontSize:"12px",
  color:"#666"
};

const downloadBtn = {
  textDecoration:"none",
  padding:"8px 14px",
  borderRadius:"8px",
  background:"#2563eb",
  color:"white",
  fontSize:"13px",
  fontWeight:"600"
};
